const PlannerCrash = () => {
  const list: any[] = [];
  list[0].intentionalCrash();
  return null;
};

export default PlannerCrash;
